@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

.credential {

	&__expiration {

		&--expired {
			color: Colors.$col-canceledRed;
		}
	}
}

.filter-container {
	display: flex;
	flex-direction: row;
	margin-right: auto;
}